EventTarget.prototype.subscribe = function (name, callback, options) {
    this.addEventListener(name, (event) => {
        let data = undefined;
        if (event instanceof CustomEvent) {
            data = event.detail;
        }
        callback(data, event);
    }, options);
};
export {};
